import { render, staticRenderFns } from "./public-frame-dark.vue?vue&type=template&id=6002062c&"
import script from "./public-frame-dark.vue?vue&type=script&lang=js&"
export * from "./public-frame-dark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports